import { render } from "./ChevronUp.vue?vue&type=template&id=21c7dc2b"
import script from "./ChevronUp.vue?vue&type=script&lang=js"
export * from "./ChevronUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__